// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2mPPq","modalFooterButton":"ModalNotes_modalFooterButton__3Ewzm"};